import React, { useEffect, useState } from "react";

const KEY = "camo_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
  };
  const reject = () => {
    localStorage.setItem(KEY, "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-black border-t border-zinc-800 px-6 md:px-12 py-5"
    >
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex-1">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-1">
            Cookie Notice
          </div>
          <p className="text-sm text-zinc-300 leading-relaxed max-w-3xl">
            We use strictly necessary cookies for authentication and a consent flag to remember your
            preference. No advertising or profiling.{" "}
            <a href="/legal/cookies" className="underline hover:text-white">Read more</a>.
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            data-testid="cookie-reject"
            onClick={reject}
            className="font-mono text-[10px] tracking-[0.3em] uppercase border border-zinc-700 px-5 py-3 hover:border-white transition"
          >
            Reject
          </button>
          <button
            data-testid="cookie-accept"
            onClick={accept}
            className="font-mono text-[10px] tracking-[0.3em] uppercase bg-white text-black px-5 py-3 hover:bg-zinc-200 transition"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
